import { useNode } from '@craftjs/core';
import { Alert, Typography } from '@mui/material';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { SwitchControl } from '../../settingsComponents';
import { EditorButtonBaseSettings } from './EditorButtonBaseSettings';

const EditorProviderButtonSettings = () => {
	const {
		startIconColorText,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onStartIconColorTextChange] = useMemo(
		() => ['startIconColorText'].map((attr) => generateOnChange(setProp, attr)),
		[setProp]
	);

	return (
		<div>
			<EditorButtonBaseSettings />
			<SwitchControl
				value={startIconColorText}
				setValue={onStartIconColorTextChange}
				label={intl.tr('screenEditor.settings.button.unicolorIcon')}
			/>
			{startIconColorText && (
				<Alert
					severity="warning"
					sx={{
						alignItems: 'center',
						mb: 2
					}}
				>
					<Typography variant="body2">
						{intl.tr('screenEditor.settings.button.unicolorIcon.warning')}
					</Typography>
				</Alert>
			)}
		</div>
	);
};

export { EditorProviderButtonSettings };
